import React from "react";

const JQuery_Remove = () => {
  return (
    <div>
      <h1>JQuery_Remove</h1>
      <p>Placeholder component for: "JQuery_Remove"</p>
    </div>
  );
};

export default JQuery_Remove;
